// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-sidebar {
  height: 50%;
}

.loader {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAeA;EAEE,WAAA;AAfF;;AAmBA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhBF","sourcesContent":["//app-alert {\n//    position: fixed;\n//    top: 60px;\n//    left: 0;\n//    right: 0;\n//    z-index: 999;\n//}\n//body, html {\n//    background-color: #3d4451;\n//    position:relative;\n//    margin:0;\n//    margin-top:30vh;\n//    width:100vw;\n//}\n\napp-sidebar{\n  //width: 100%;\n  height: 50%;\n  \n}\n\n.loader {\n  height:100vh;\n  width:100%;\n  display:flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.rDNA-wrapper {\n  //width: 100%;\n  //height: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
